<template>
	<v-layout row wrap mb-1>
        <v-flex xs12 v-if="!editing">
            <span class="font-weight-bold">{{ label }}</span>
        </v-flex>
        <v-flex xs12 v-if="!noValue && !editing">
            <value-or-na ref="valueEdit" :value="value" :editable="editable" :color="color" :editOnFocus="editOnFocus" :editOnEnter="editOnEnter" @edit="edit"></value-or-na>
            <slot v-if="prependIcon" v-bind:commit="commit" name="prependIcon"></slot>
        </v-flex>
        <v-flex xs12 v-if="editing">
            <slot v-bind:commit="commit" name="edit"></slot>
        </v-flex>
    </v-layout>
</template>

<script>
import ValueOrNa from '@/components/generic/ValueOrNa.vue';

export default {
    components: {
        ValueOrNa
    },
    data() {
        return {
            editing: false
        }
    },
    props: [
        'label',
        'value',
        'noValue',
        'editable',
        'color',
        'editOnFocus',
        'editOnEnter',
        'prependIcon'
    ],
    methods: {
        commit() {
            this.editing = false;

            if (this.editOnEnter) {
                this.$nextTick(() => {                
                    if(this.$refs.valueEdit) {
                        if (this.$refs.valueEdit.$refs.edit1) {
                            this.$refs.valueEdit.$refs.edit1.$el.focus();                        
                        }
                        if (this.$refs.valueEdit.$refs.edit2) {
                            this.$refs.valueEdit.$refs.edit2.$el.focus();                        
                        }
                    }               
                });
            }
        },
        edit() {
            this.editing = true;
            this.$emit("edit");
        }
    }
}
</script>